// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
import Rails from '@rails/ujs'
Rails.start()

// Import Trix and Action Text
import Trix from 'trix'
import '@rails/actiontext'

// Import Trix styles
import 'trix/dist/trix.css'
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// Create Vue App
// import { createApp } from "vue";
// import VueAxios from "vue-axios";
// import axios from "axios";

// Import App Components
// import TestApp from "../components/TestApp.vue"
//
//
// const test_app = createApp(TestApp).mount('#test-app')

// About page read more button functionality
document.addEventListener('DOMContentLoaded', () => {
  const readMoreButton = document.querySelector('.about-content-read-more');
  if (readMoreButton) {
    readMoreButton.addEventListener('click', () => {
      const mobileContents = document.querySelectorAll('.about-content-mobile');
      mobileContents.forEach(content => {
        content.style.display = 'block';
      });
      readMoreButton.style.cssText = 'display: none !important;'
    });
  }
});
